export const DEFAULT_FLAG = '/icons/logo.png';
